// Detects Capacitor native runtime and initializes native plugins when present.
// In a web build this module is a no-op — no Capacitor SDK is bundled.

declare global {
  interface Window {
    // Injected by the Capacitor bridge when running inside a native shell.
    Capacitor?: {
      isNativePlatform: () => boolean;
      getPlatform: () => 'ios' | 'android' | 'web';
    };
  }
}

export function isNative(): boolean {
  return typeof window !== 'undefined' && !!window.Capacitor?.isNativePlatform();
}

export function nativePlatform(): 'ios' | 'android' | 'web' {
  return window.Capacitor?.getPlatform() ?? 'web';
}

// eslint-disable-next-line no-new-func
const _dynImport = new Function('pkg', 'return import(pkg)') as (pkg: string) => Promise<unknown>;

export async function initNativePlugins(): Promise<void> {
  if (!isNative()) return;

  // Packages installed by `npx cap add ios/android` — not present in web workspace.
  // new Function bypasses Vite's static import analysis so the web build stays clean.
  try {
    const { SplashScreen } = (await _dynImport(
      '@capacitor/splash-screen',
    )) as typeof import('@capacitor/splash-screen');
    await SplashScreen.hide({ fadeOutDuration: 300 });
  } catch {
    // not available in web build
  }

  try {
    const { StatusBar, Style } = (await _dynImport(
      '@capacitor/status-bar',
    )) as typeof import('@capacitor/status-bar');
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#0f172a' });
  } catch {
    // not available in web build
  }
}
